import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import SpriteUtils from "@/utils/sprite-utils";
import Sprite = Phaser.GameObjects.Sprite;
import CU from "@/utils/c-u";

export class SoloIntroPanel extends Phaser.GameObjects.Container {

    protected onAcceptCallback: (() => unknown) | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, subtitle: string, atlasKey: string | undefined,
                iconKey: string, blockFirstText: string, blockSecondText: string,
                onAcceptCallback: () => unknown) {
        super(scene);
        this.x = canvas.width / 2;
        this.y = canvas.height / 2 - 30;

        this.setDepth(2001);

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);
        this.preInit(scene, canvas);

        let window = SpriteUtils.addImage(this.scene, 0, 0, Keys.UI_WINDOW_MIDDLE_BIG).setOrigin(0.5, 0.5);
        this.add(window);

        let titleEl = TextUtils.addTextByFamily(this.scene, title, 0, -262, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        this.add([window, titleEl]);

        this.onAcceptCallback = onAcceptCallback;

        let nameText = TextUtils.addTextByFamily(scene, subtitle, 0, -180,
            '#ffd465', 18, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

        let light = SpriteUtils.addSprite(this.scene, -135, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = atlasKey ? SpriteUtils.addSprite(this.scene, -150, -100, atlasKey, iconKey) : SpriteUtils.addSprite(this.scene, -150, -100, iconKey);

        let blockFirst = TextUtils.addTextAdvanced(scene, blockFirstText, 55, -90,
            '#a2ff82', 15, 'normal', 280, 'center', 2, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, blockFirst]);
        this.afterIconInit(scene, icon);

        let blockSecond = TextUtils.addTextByFamily(scene, blockSecondText,
            0, blockFirst.y + 110, '#FFD465', 15, 'normal', 450, Fonts.ARIAL_MT);
        this.add(blockSecond);

        this.addCustomButton(0, 150,Tr('otlichno').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, onAcceptCallback);
    }

    protected preInit(scene: Scene, canvas: HTMLCanvasElement) {
        let background = this.scene.add.sprite(0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);
    }

    protected afterIconInit(scene: Scene, icon: Sprite) {

    }

    protected addCustomButton(x: number, y: number, text: string, buttonBackground: string,
                              buttonAtlas: string | undefined, buttonIcon: string,
                              callback?: () => unknown) {
        let okButton = new SquareButton(this.scene, x, y, 0, buttonBackground,
            buttonAtlas, buttonIcon, text.toLocaleUpperCase(), false);

        okButton.setCallback(() => {
            if (callback != null) {
                callback();
            }
        });

        this.add(okButton);
    }

    public open(): void {
        this.scene.add.existing(this);
    }

    public openAnimated(): void {
        this.open();
        this.setAlpha(0);
        SpriteUtils.scale(this, 0.92);

        this.scene!.tweens.add({
            targets: this,
            alpha: 1,
            scale: 1,
            delay: 0,
            duration: 200
        });
    }

    public close(): void {
        this.setVisible(false);
        this.destroy();
    }
}
